import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledSelectSearch = styled.div`
  width: 100%;
  position: relative;
  .input-label {
    line-height: 24px;
  }
  .select-btn-select-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    height: 44px;
    padding-left: 16px;
    padding-right: 4px;
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    cursor: pointer;
    border: 1px solid ${COLOR.indigo[16]};
    border-radius: 8px;
    background-color: ${COLOR.white};
  }
  .select-btn-select-search-disabled {
    cursor: not-allowed;
  }
  .select-search-error {
    border: 1px solid ${COLOR.functionalRed.default};
  }
  .select-btn-select-search-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
  }
  .select-custom {
    background-color: #fff;
    position: absolute;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
    overflow-y: auto;
    border-radius: 12px;
    z-index: 99;
    top: 71px;
    width: 100%;
    .dropdown__menu_search {
      width: 100%;
    }
  }
  .select-custom::-webkit-scrollbar {
    width: 8px;
  }

  .select-custom::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  .select-custom::-webkit-scrollbar-thumb {
    border-radius: 12px;
  }
`;
